// extracted by mini-css-extract-plugin
export default {"root":"Search_root__+MZTq","input":"Search_input__Zzyrl","iconWrapper":"Search_iconWrapper__bNtbV","icon":"Search_icon__tZsRI","clearButton":"Search_clearButton__nFAOT"};